import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { KompisQrCode } from '@inter-ikea-kompis/react-components';
import Body from 'ui/Typography/Body';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import { useAvailability } from 'contexts/availability';
import { getDesignLink } from 'views/Summary/utils';

const QrCodeContainer = styled.div`
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 2fr 3fr;
  gap: ${({ theme }) => theme.space.md};
  margin: ${({ theme }) => theme.space.s} 0;

  &[data-vertical='true'] {
    display: flex;
    flex-direction: column-reverse;
    margin: 0;
  }

  &[data-print='true'] {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap-reverse;
    margin: 0;
    text-align: right;
  }
`;

const StyledQrCode = styled(KompisQrCode)`
  &[data-vertical='true'] {
    padding: ${({ theme }) => theme.space.l};
  }
  &[data-print='true'] {
    padding: 0;
    width: 60%;
  }
`;

type Props = {
  vertical?: boolean;
  print?: boolean;
  vpcCode: string;
};

const QrCode = ({ vertical, vpcCode, print }: Props) => {
  const { storeId } = useAvailability();
  const { formatMessage } = useIntl();

  const qrCodeUrl = getDesignLink(storeId, vpcCode);

  return (
    <QrCodeContainer
      data-qr-code={qrCodeUrl}
      data-testid="qr-code"
      data-vertical={vertical}
      data-print={print}
    >
      {/* @ts-ignore */}
      {qrCodeUrl && <StyledQrCode data-vertical={vertical} url={qrCodeUrl} data-print={print} />}
      <Body type={ThemeFontStyleTypeEnum.bodyMedium}>
        {formatMessage({ id: 'storageone.saveDesignQrCodeCaption' })}
      </Body>
    </QrCodeContainer>
  );
};

export default QrCode;
